<template>
  <main>
    <div class="row">
      <div class="col-7">
        <div class="flex--item align--center text--medium text--normal-size">
          {{ equipmentData.equipmentName }}
          <div :id="'tag-popover' + equipmentData.id">
            <feather-icon icon="TagIcon" size="12" class="tag-icon--style" />
          </div>
          <b-popover
            ref="popover"
            :target="'tag-popover' + equipmentData.id"
            triggers="hover"
            placement="right"
            container="my-container"
            boundary="window"
          >
            <template v-slot:title>
              <div class="d-flex justify-content-between align-items-left">
                <span class="text--normal-size">Tag</span>
              </div>
            </template>
            <div class="badge__container">
              <b-badge
                v-for="(tag, index) in equipmentData.tag"
                :key="index"
                variant="light-primary"
                class="badge--style tag--space"
              >
                {{ tag }}
              </b-badge>
            </div>
          </b-popover>
        </div>
        <div class="text--light text--small-size text--color-secondary">
          {{ equipmentData.equipmentIp }}
        </div>
      </div>
      <div class="col-5 text-right">
        <div class="text--medium text--normal-size">
          {{ equipmentData.date }}
        </div>
        <div class="text--light text--small-size text--color-secondary">
          {{ equipmentData.time }}
        </div>
      </div>
    </div>

    <div class="flex--item align--center margin-top--custom">
      <b-badge
        pill
        :variant="badgeVariant"
        class="badge--width text--small-size"
      >
        {{ equipmentData.resources }}
      </b-badge>
      <div class="d-flex justify-content-end container__equipment-value margin-left--custom text--bold text--normal-size">
        {{ equipmentData.value + " " + policyUnit }}
      </div>
      <div :id="'alert-icon' + equipmentData.id" class="margin-left--custom">
        <feather-icon
          :ref="'alert-icon' + equipmentData.id"
          icon="AlertTriangleIcon"
          class="alert__icon--active-style"
        />
      </div>
      <b-tooltip
        :target="'alert-icon' + equipmentData.id"
        placement="right"
        boundary="window"
        variant="warning"
      >
        <div class="textbox__warning-value--style">
          <span>Warning</span>
          <span>{{
            equipmentData.warningValue
              ? equipmentData.warningValue + " " + policyUnit
              : "-"
          }}</span>
        </div>
        <div class="textbox__danger-value--style">
          <span>Critical</span>
          <span>{{
            equipmentData.criticalValue
              ? equipmentData.criticalValue + " " + policyUnit
              : "-"
          }}</span>
        </div>
      </b-tooltip>
    </div>
    <hr />
  </main>
</template>

<script>
import { BBadge, BPopover, VBTooltip, BTooltip } from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
export default {
  components: { BBadge, BPopover, VBTooltip, BTooltip },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  name: "MoleculeEventCard",
  props: {
    equipmentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    badgeVariant() {
      if (this.equipmentData.status === 0) return "light-primary"
      else if (this.equipmentData.status === 1) return "light-warning"
      else return "light-danger"
    },
    policyUnit() {
      if (this.equipmentData.policyUnit.toLowerCase() !== "percent")
        return this.equipmentData.policyUnit
      else return "%"
    },
  },
}
</script>

<style lang="scss" scoped>
hr {
  margin-top: 10px;
  margin-bottom: 10px;
}

.text--bold {
  font-weight: 600;
}

.text--medium {
  font-weight: 500;
}

.text--light {
  font-weight: 400;
}

.text--normal-size {
  font-size: 12px;
}

.text--small-size {
  font-size: 10px;
}

.text--color-secondary {
  color: #b9b9c3;
}

.flex--item {
  display: flex;
}

.align--center {
  align-items: center;
}

.item--right {
  justify-self: end;
}

.badge--width {
  width: 68px;
}

.margin-top--custom {
  margin-top: 10px;
}

.margin-left--custom {
  margin-left: 10px;
}

.textbox__warning-value--style {
  display: flex;
  justify-content: space-between;
  color: #ff9f43;
  font-weight: 400;
  font-size: 14px;
}

.textbox__danger-value--style {
  display: flex;
  justify-content: space-between;
  color: #ea5455;
  font-weight: 400;
  font-size: 14px;
}

.alert__icon--active-style {
  color: #b9b9c3;
}

.tag-icon--style {
  color: #9d95f5;
  margin-left: 8px;
}

.badge--style {
  max-width: 30ch;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag--space {
  margin-left: 4px;
  margin-bottom: 4px;
}

.container__equipment-value {
  width: 75px;
}
</style>
